import { useEffect } from "react";

import "./Incubation.css";
import { Backtotop, Floatinmenu, Underline, ModalCardTwo} from "../../widgets";
import { FaComputer } from "react-icons/fa6";
import { incubation_menu,incubation_laboratories,incubation_img_corousal} from "../../constants/incubation";

import { RadialMenu,Heroimagecarousal} from "../../components";






const Incubation_Laboratories = () => {
  useEffect(() => {
    document.title = 'ACCET- Incubation';
  }, []);
  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />

      {/* <div className="incubationbg">
        <div className="incubationheading">
          Alagappa Incubation Forum
        </div>
      </div> */}
      <section className="incubationdark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu}/>
         <div className="incubation_cards row">
          <Underline heading="AIF R & D Laboratory" />
              {incubation_laboratories.map((item) => (
                <ModalCardTwo key={item.id} heading={item.heading} pic={item.pic} />
              ))}
            </div>
      </section>
      
      <Backtotop />
    </div>
  );
};

export default Incubation_Laboratories;
